enum WorkspaceProjectCarbonRemovalPoolArea {
  hectare = 'hectare',
  area = 'area',
}

export default WorkspaceProjectCarbonRemovalPoolArea
